<arm-dialog (onCancel)="cancel()"
            (onSubmit)="submit()"
            [hideOkButton]="!isAuthorized"
            [disabled]="!mapForm.form.valid"
            [title]="'Edit NODE'">

  <form #mapForm="ngForm" autocomplete="off" class="offline-nodes-dialog">
    <mat-form-field class="fullWidth">
      <mat-label>Name</mat-label>
      <input [(ngModel)]="data.selectedItem.name" [disabled]="!data.selectedItem.isOffline"
             matInput name="name" minlength="1" maxlength="255">
      <mat-error>
        Name is <strong>required</strong>
      </mat-error>
    </mat-form-field>

    <mat-form-field class="fullWidth">
      <mat-label>Teams Role</mat-label>
      <mat-select [(ngModel)]="data.selectedItem.teamsRole" name="teamsRole">
        <mat-option *ngFor="let item of teamsRoleOptions" [value]="item.value">
          {{item.text}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <p *ngIf="data.selectedItem.productType === 'GW' && (data.selectedItem.teamsRole === 'REMOTE' || data.selectedItem.teamsRole === 'PROXY')"
      class="remote-teams-notice">
      Picking teams role for GW has no effect on the configuration
    </p>
    <p *ngIf="data.selectedItem.productType === 'HYBRID' && data.selectedItem.teamsRole === 'PROXY'"
       class="remote-teams-notice">
      Picking teams role for Hybrid other than Remote has no effect on the configuration
    </p>

    <mat-form-field class="fullWidth">
      <mat-label>Address</mat-label>
      <input [(ngModel)]="data.selectedItem.addressForGUI" [disabled]="!data.selectedItem.isOffline"
             matInput name="addressForGUI">
    </mat-form-field>

    <mat-radio-group class="address-type" *ngIf="!data.isEditMode" [(ngModel)]="data.selectedItem.isIpAddressProvidedForGUI"
                     [ngModelOptions]="{standalone: true}">
      <div class="form-row">
        <div class="form-column">
          <mat-radio-button color="primary" [value]="true">IP Address</mat-radio-button>
        </div>
        <div class="form-column">
          <mat-radio-button color="primary" [value]="false">Hostname</mat-radio-button>
        </div>
      </div>
    </mat-radio-group>

    <ac-input-container label="Operative state">
      <ac-select [acModel]="data.selectedItem.operState.state"
                 (acModelChange)="data.selectedItem.operState.state = $event"
                 [searchable]="false"
                 [items]="operStateOptions">
      </ac-select>
    </ac-input-container>

    <mat-form-field class="fullWidth">
      <mat-label>Protocol</mat-label>
      <mat-select [(ngModel)]="data.selectedItem.transportType" name="transportType">
        <mat-option *ngFor="let item of transportTypeOptions" [value]="item.value">
          {{item.text}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <ng-container *ngIf="isAuthorized">
      <ac-line-separator [(collapsed)]="isCollapsed" [isCollapsible]="true" title="Credentials">
        <div class="node-dialog-advanced-configuration">
          <mat-form-field class="fullWidth">
            <mat-label>
              <span class="device-before-arrow">Configurator</span><i aria-hidden="true"
                                                                      class="fa fa-long-arrow-right fa-lg"></i><span
              class="device-after-arrow">Node</span>
            </mat-label>
            <mat-select [(ngModel)]="data.selectedItem.credentialsId" name="credentialsId">
              <mat-option *ngFor="let item of data.nodeCredentials" [value]="item.id">
                {{item.description}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="fullWidth">
            <mat-label>
              <span class="device-before-arrow">Node</span><i aria-hidden="true"
                                                              class="fa fa-long-arrow-right fa-lg"></i><span
              class="device-after-arrow">Configurator</span>
            </mat-label>
            <mat-select [(ngModel)]="data.selectedItem.operatorId" name="operatorId">
              <mat-option *ngFor="let item of data.nodeUsers" [value]="item.id">
                {{item.userName}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </ac-line-separator>
    </ng-container>
  </form>
</arm-dialog>
